<ag-grid-angular
  class="ag-theme-alpine"
  [serverSideInfiniteScroll]="true"
  [pagination]="true"
  [paginationPageSize]="1000"
  [cacheBlockSize]="500"
  [maxBlocksInCache]="40"
  [maxConcurrentDatasourceRequests]="1"
  [rowGroupPanelShow]="'never'"
  [pivotPanelShow]="'always'"
  [enableRangeSelection]="false"
  [rowModelType]="'serverSide'"
  [columnDefs]="columnDefs"
  [suppressCopyRowsToClipboard]="true"
  [defaultColDef]="defaultColDef"
  (cellValueChanged)="cellValueChanged($event)"
  [getContextMenuItems]="getContextMenuItems"
  [animateRows]="false"
  [suppressRowClickSelection]="false"
  [stopEditingWhenCellsLoseFocus]="false"
  (gridReady)="onGridReady($event)"
></ag-grid-angular>
